import { createAction } from "redux-starter-kit";
import { normalize } from "normalizr";
import { debounce } from "lodash";
import { addEntities } from "../../entities";
import {
  FETCH_DEBTORINVOICES_FAILURE,
  FETCH_DEBTORINVOICES_REQUEST,
  FETCH_DEBTORINVOICES_SUCCESS
} from "../types";

const debouncedQueryDebtorInvoices = debounce(
  async (dispatch, schema, api, id, ordering, limit, offset, filters) => {
    dispatch(
      createAction(FETCH_DEBTORINVOICES_REQUEST)({
        id,
        limit,
        offset,
        ordering
      })
    );
    const response = await api.debtors.getDebtorInvoices(
      id,
      ordering,
      limit,
      offset,
      filters
    );
    const data = normalize(response.results, [schema.fundingRequest]);
    dispatch(addEntities(data.entities));
    dispatch(
      createAction(FETCH_DEBTORINVOICES_SUCCESS)({
        items: data.result,
        count: response.count
      })
    );
    return response;
  },
  1000,
  { trailing: true }
);

const queryDebtorInvoices = (
  id,
  ordering,
  limit,
  offset,
  filters = {}
) => async (dispatch, getState, { api, schema }) => {
  try {
    await debouncedQueryDebtorInvoices(
      dispatch,
      schema,
      api,
      id,
      ordering,
      limit,
      offset,
      filters
    );
  } catch (err) {
    dispatch(createAction(FETCH_DEBTORINVOICES_FAILURE)(err));
    throw err;
  }
};

export default queryDebtorInvoices;
